import React from 'react';
import styled from 'styled-components';
import {DisableColor} from '../../Colors';

const Button = styled.button`
    text-decoration: none;
    text-transform: none;
    background-color : transparent;
    border : none;
    &:focus{
        outline : 0;
    }
    &:disabled{
        color : ${DisableColor};
    }
`;

const ButtonComponent = ({icon=null,...props}) => {
	if(icon){
		return <Button {...props} >{icon}</Button>;
	}
	return <Button {...props} />;
};

export default ButtonComponent;